import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addsponser',
  templateUrl: './addsponser.component.html',
  styleUrls: ['./addsponser.component.css']
})
export class AddsponserComponent implements OnInit,AfterViewInit {

  @ViewChildren('input')firstipcontrol;


  formname:String="Sponser"; 

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
isprivilage: boolean = false;
showProgress: boolean = false;

//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;
//Edit Get Values
sponserColl:any=[];
sponserBO:any={};

sponserid:number=0

sponserform=new FormGroup({
  sponserid:new FormControl(0),          
  sponsername:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});

@Input() ischild :boolean=false;
@Input() ischildadd :boolean=false;
@Input() ischildkey :number=0
@Output() childChanged = new EventEmitter<number>();


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.sponserid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.sponserform.reset();
       this.fnInitializeFormGroup(); 

       if(this.sponserid>0){
         this.fngetSponser();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.sponserid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}
ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}
fnInitializeFormGroup(){
   this.sponserform.setValue({
    sponserid:0,    
    sponsername:'',
     inactive:false              
   })
}

//Get 
fngetSponser() { 
  if (this.showProgress) {
    return;
  }        
     var data = {
       'sponserid':this.sponserid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getSponser(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){  
          this.fnHideProgress();

           this.sponserColl=res.json().result;
           var editdata = this.sponserColl[0];        
           this.fnEditMode(editdata);
           this.sponserBO=editdata;
         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{  
      this.fnHideProgress();
        
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{ if (this.saveloading) {
    return;
  }

     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.sponserform.valid){ this.saveloading = true;
         //Check
         var data = {
               'sponserid': this.sponserid,                      
               'sponsername':this.sponserform.get('sponsername').value, 
               'inactive':this.sponserform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckSponser(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.sponserform.get('sponserid').value>0){
                       //Update 
                       this.fnSetSponser(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertSponser(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){ this.saveloading = false;
                       this.sponserform.controls['sponsername'].setErrors({'notfound': true});
                     }
               }
             }
             else { this.saveloading = false;
               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{ this.saveloading = false;
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){ this.saveloading = false;
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertSponser(data){    
 
   this.appService.fnInsertSponser(data).subscribe(
     (res)=>{ this.saveloading = false;
       if(res.json().status===200){  
         if(res.json().result!=""){

          this.ischildkey=res.json().result[0][0].sponserid;
           this.ischildadd=true;


           this.toastr.success('', "The new sponser has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.sponsername);

           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{ this.saveloading = false;
       this.toastr.error('Error', err);
     });

}

//Set
fnSetSponser(data){    

this.appService.fnSetSponser(data).subscribe(
 (res)=>{ this.saveloading = false;
   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The sponser has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.sponserid,data.sponsername);

             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{ this.saveloading = false;
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  
  if(this.ischild===false){
    this.router.navigate(['/Sponser']);
  }
  else{
    var pBO:any={
      isadd:this.ischildadd,
      childkey:this.ischildkey,
      doctype:'SPONSER'    
    }
    this.childChanged.emit(pBO);
  }

}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.sponserform.setValue({ 
  sponserid:deptBO.sponserid,     
  sponsername:deptBO.sponsername,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}
private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}







}
